import emailPostClicksView from './emailPostClicksComponent.html';
import { ensure } from 'components/sharpr/ensure/ensure.js';
import './emailPostClicksComponent.css';

export function emailPostClicksComponent() {
	return {
		bindings: {
			stats: '<',
			emailId: '<',
			isLoading: '<',
		},
		transclude: true,
		controllerAs: 'vm',
		controller: emailPostClicksComponentCtrl,
		template: emailPostClicksView,
	};
}

export class emailPostClicksComponentCtrl {
	constructor($element, Api, Cfg) {
		'ngInject';
		this.$element = $element;
		this.Api = Api;
		this.Cfg = Cfg;
	}

	$onInit() {
		this.openPostDetails = false;
		this.hideLikesAndComments = this.Cfg.read('Features.hide_likes_and_comments') !== '0';
	}

	/**
	 * Get list of clicks, comments, and likes for this post
	 * @param postId
	 */
	getDetails(postId) {
		this.openPostDetails = postId;
		if (!this.stats.clicks[postId]) {
			this.loadingPost = postId;
			this.Api.get(`/emails/${this.emailId}/stats?summary_only=false&post_id=${postId}`).then(postStats => {
				this.stats.clicks[postId] = ensure
					.array(postStats.clicks[postId])
					.map(({ IntelEmailClick, User }) => Object.assign(IntelEmailClick, { user: User }));

				this.stats.likes[postId] = ensure
					.array(postStats.likes[postId])
					.map(({ PostLike, User }) => Object.assign(PostLike, { user: User }));

				this.stats.comments[postId] = ensure.array(postStats.comments[postId]).map(({ Comment, User }) => ({
					text: Comment.comment,
					date_created: Comment.created,
					commenter: User,
				}));

				this.loadingPost = false;
			});
		}
	}

	/**
	 * Gets location of each post in the email preview and the location of the corresponding percent
	 * overlay and details overlay. Places and sizes the two overlays inside the post.
	 */
	putStatsInPlace() {
		let emailHtmlContainer = this.$element[0];
		let statsTopModify = 30;
		// in case they have scrolled
		let topOffset = window.pageYOffset;
		let leftOffset = window.pageXOffset;
		this.stats.postIds.forEach(postId => {
			let postEl = emailHtmlContainer.querySelector(`.email-post[data-id="${postId}"]`);
			if (!postEl) {
				return;
			}
			let postRect = postEl.getBoundingClientRect();
			let statsEl = emailHtmlContainer.querySelector(`.percent-overlay[data-id="${postId}"]`);
			if (!statsEl) {
				return;
			}
			let detailsEl = emailHtmlContainer.querySelector(`.preview-overlay[data-id="${postId}"]`);
			if (!detailsEl) {
				return;
			}

			if (postRect.height < 120) {
				statsTopModify = 10;
			}

			statsEl.style.top = Math.round(postRect.top + statsTopModify + topOffset) + 'px';
			statsEl.style.left = Math.round(postRect.left + 10 + leftOffset) + 'px';
			// details needs position and h/w modified
			detailsEl.style.top = Math.round(postRect.top + topOffset - 1) + 'px';
			detailsEl.style.left = Math.round(postRect.left + leftOffset) + 'px';
			detailsEl.style.height = postRect.height < 90 ? postRect.height * 3 + 'px' : postRect.height + 1 + 'px';
			detailsEl.style.width = postRect.width + 'px';

			statsEl.style.visibility = 'visible';
		});
	}

	/**
	 * Calculate percentage of clicks on a post out of all possible clicks
	 * @param postId
	 * @returns {float}  a float representing the percentage
	 */
	calculatePercentage(postId) {
		let numerator = this.stats.summary.click_count_by_post[postId];
		let denominator = this.stats.summary.total_clicks_possible;

		return numerator / denominator;
	}
}
